import api from './axios';

export const getLocais = () =>
  api.get('/locais').then((r) => r.data);

export const createLocal = (data) =>
  api.post('/locais', data).then((r) => r.data);

export const updateLocal = (id, data) =>
  api.patch(`/locais/${id}`, data).then((r) => r.data);

export const deleteLocal = (id) =>
  api.delete(`/locais/${id}`);
